<div *ngIf="item" class="testimonials-panel-info">

  <!-- Without big pictures enabled -->
  <div *ngIf="!item.bigPictures"
       class="testimonials-panel-info__normal-pictures">
    <p *ngIf="item.author?.value" class="testimonials-panel-info__author">
      {{ item.author.value }}
    </p>
    <p *ngIf="item.position?.value" class="testimonials-panel-info__position">
      {{ item.position?.value }}
    </p>

    <div class="testimonials-panel-info__quote--small-pictures"
         [innerHTML]="item.quote?.value">
    </div>
    <ng-container *ngIf="item.link?.value?.length > 0">
      <ng-container *ngTemplateOutlet="itemlink"></ng-container>
    </ng-container>
  </div>

  <!-- With big pictures enabled -->
  <div *ngIf="item.bigPictures"
       class="testimonials-panel-info__big-pictures">
    <div class="testimonials-panel-info__big-pictures--info-container"
         [class.testimonials-panel-info__big-pictures--info-container-move-up]="showQuote && item.readMoreDescriptionButton?.value?.length">
      <div class="testimonials-panel-info__text" #textEl>
        <strong *ngIf="item.author?.value"
                class="testimonials-panel-info__big-pictures__author">
          {{ item.author.value }}
        </strong>
        <div *ngIf="item.position?.value"
             class="dot-separator"
             aria-hidden="true">
        </div>
        <strong *ngIf="item.position?.value" class="testimonials-panel-info__big-pictures__position">
          {{ item.position?.value }}
        </strong>
      </div>

      <div *ngIf="item.subtitle?.value" class="testimonials-panel-info__big-pictures__subtitle">
        {{ item.subtitle.value }}
      </div>

      <div *ngIf="item.readMoreDescriptionButton?.value"
           class="testimonials-panel-info__quote--big-pictures"
           [class.testimonials-panel-info__quote--expanded]="showQuote"
           [class.testimonials-panel-info__quote--hidden]="!showQuote"
           [innerHTML]="item.quote?.value"
           [@fadeInOut]>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="itemlink"></ng-container>

  </div>
</div>

<ng-template #itemlink>
  <div class="testimonials-panel-info__links" #linksEl>

    <div *ngIf="item.quote?.value && item.readMoreDescriptionButton?.value?.length"
         [ngClass]="(readMoreButtonClass || '') + ' testimonials-panel-info__read-more testimonials-panel-info__button'"
         (click)="readMoreClick()">
      <span class="testimonials-panel-info__read-more--link">
        {{ showQuote ? readLessButtonText : readMoreButtonText }}
      </span>
    </div>

    <ng-container *ngIf="item.link?.value?.length > 0">
      <app-bg-button *ngFor="let link of (item.link?.value || [])"
                     [buttonColor]="link?.color?.value || null"
                     class="testimonials-panel-info__button"
                     [data]="link.link.value || null">
      </app-bg-button>
    </ng-container>
  </div>
</ng-template>
